import React, { forwardRef } from "react";
import { Modal as FlowbiteModal } from "flowbite-react";
import useExitTransition from "../../hooks/useExitTransition";

/**
 * Substitui o `Modal` do flowbite-react: mesma API (props e `Modal.Header/Body/
 * Footer`), mas ao fechar (`show` -> false) mantém o modal montado pelo tempo
 * da animação de saída (pop-out) antes de desmontar. A entrada (pop-in) é CSS
 * puro em styles/animations.css.
 *
 * Observação: o Flowbite devolve `null` quando `show` é falso, então sem este
 * wrapper o modal sumia de uma vez, sem como animar a saída.
 */
const AnimatedModal = forwardRef(function AnimatedModal(
  { show, className, ...props },
  ref,
) {
  const { render, closing } = useExitTransition(Boolean(show));
  if (!render) return null;

  return (
    <FlowbiteModal
      ref={ref}
      {...props}
      show
      className={[className, closing ? "rs-modal-closing" : ""]
        .filter(Boolean)
        .join(" ")}
    />
  );
});

AnimatedModal.Header = FlowbiteModal.Header;
AnimatedModal.Body = FlowbiteModal.Body;
AnimatedModal.Footer = FlowbiteModal.Footer;

export default AnimatedModal;
export { AnimatedModal as Modal };
